import React from "react";

/**
 * Handles change of size for text or shape.
 *
 * @param {string}   view     String for mobile or desktop view
 * @param {Object}   canvas   FabricJS Canvas Object
 *
 * @returns {Object}
 */
export default function Size({ view, canvas }) {
  const changeFontSize = () => {
    const className = view == "mobile"
      ? ".details-container-mobile"
      : ".details-container-inner";
    const size = document.querySelectorAll(className + " #fontSize")[0] || null;
    const activeObject = canvas.getActiveObject() || null;

    if (activeObject === null || size === null) {
      return;
    }

    /**
     * If activeObject is text, change font size
     * Else change the scale, this changes the size for
     * other types of fabric objects
     */
    activeObject.text
      ? activeObject.set('fontSize', size.value)
      : activeObject.set({
          scaleX: size.value / 100,
          scaleY: size.value / 100
        });
    canvas.renderAll();
  }

  return (
    <div id="sizeTool" className="text-tool-inner">
      <label htmlFor="fontSize">Size</label>
      <input type="range" min="1" max="2000" id="fontSize" defaultValue="1" onChange={() => changeFontSize()}></input>
    </div>
  );
}
